import firebase from 'firebase';

const config = {
  apiKey: "AIzaSyA-sdQZugYMdGo4MMQEjkBtjRFE46NaGoU",
  authDomain: "art-trove.firebaseapp.com",
  databaseURL: "https://art-trove-default-rtdb.firebaseio.com",
  projectId: "art-trove",
  storageBucket: "art-trove.appspot.com",
  messagingSenderId: "864562139624",
  appId: "1:864562139624:web:65cafd7d8fe0969bc3545d",
  measurementId: "G-64PKL4D6VM"
};

firebase.initializeApp(config);
const database = firebase.database();

export default database;




// WEBPACK FOOTER //
// ./src/database.js